export default class QuickLinks {
    /**
        * Class constructor *
        * @arg {object} - `quickLinksElement` check for the
        * quick links element.
    **/
    constructor (quickLinksElement) {
        if (!quickLinksElement) return;

        this.quickLinksElement = quickLinksElement;
        this.links = this.quickLinksElement.querySelectorAll('.js-quick-links-link');
        this.images = this.quickLinksElement.querySelectorAll('.js-quick-links-image');
        this.init()
    }

    init() {
        this.links.forEach(link => {
            link.addEventListener("mouseover", () => {
                this.images.forEach(image => {
                    if (image.dataset.index === link.dataset.index) {
                        image?.classList.remove('opacity-0');
                        image?.classList.add('opacity-100');
                    } else {
                        image?.classList.add('opacity-0');
                        image?.classList.remove('opacity-100');
                    }
                })
            });
        });
    }
}
